module.exports = __webpack_public_path__ + "img/search-big-icon.5a0cb542.svg";